import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useMonthlyQueriesByUsername } from "../../../hooks/StatisticsHooks";

/**
 * To draw the monthly queries by username bar chart
 */
export const MonthlyQueriesByUsernameVisualization = ({ username, startDate, endDate }) => {
  const { data } = useMonthlyQueriesByUsername(username, startDate, endDate);

  return (
    <ResponsiveContainer width="100%" height={635} margin={{ right: 50 }}>
      <BarChart data={data} margin={{ top: 20, right: 50 }}>
        <Legend verticalAlign="top" height={50} iconSize={30} />
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="mmYYYY" name="mmYYYY" />
        <YAxis dataKey="numberOfTimes" name="numberOfTimes" />
        <Tooltip />
        <Legend />
        <Bar dataKey="numberOfTimes" fill="#5182BB" name="Number of times" />
      </BarChart>
    </ResponsiveContainer>
  );
};
